export const CARD_BRAND_BADGE_WIDTH_PX = 48;
export const CARD_BRAND_BADGE_HEIGHT_PX = 28;
export const INVALID_CARD_BADGE_WIDTH_PX = 36;

export type CardBrandLaneState = 'accepted' | 'invalid' | 'visa' | 'mastercard';

const BADGE_GAP_SPACING_UNITS = 2;
const LANE_END_INSET_SPACING_UNITS = 3;
const ACCEPTED_BRAND_BADGE_COUNT = 2;

const repeatedLength = (value: string, count: number): string =>
  Array.from({ length: count }, () => value).join(' + ');

/**
 * Geometry for the SDK-owned lane beside the secure provider region.
 *
 * The lane is deliberately physical rather than an overlay. Browser and
 * password-manager controls injected inside the provider realm therefore end
 * at the provider boundary and cannot occupy the same pixels as card brands.
 */
export const resolveCardBrandLaneGeometry = (
  spacingUnit: string,
  state: CardBrandLaneState = 'accepted',
): { badgeGap: string; endInset: string; laneWidth: string } => {
  const visibleBadgeWidth =
    state === 'accepted'
      ? CARD_BRAND_BADGE_WIDTH_PX * ACCEPTED_BRAND_BADGE_COUNT
      : state === 'invalid'
        ? INVALID_CARD_BADGE_WIDTH_PX
        : CARD_BRAND_BADGE_WIDTH_PX;
  const visibleGapUnits = state === 'accepted' ? BADGE_GAP_SPACING_UNITS : 0;

  return {
    badgeGap: `calc(${repeatedLength(spacingUnit, BADGE_GAP_SPACING_UNITS)})`,
    endInset: `calc(${repeatedLength(spacingUnit, LANE_END_INSET_SPACING_UNITS)})`,
    laneWidth: `calc(${visibleBadgeWidth}px + ${repeatedLength(
      spacingUnit,
      visibleGapUnits + LANE_END_INSET_SPACING_UNITS,
    )})`,
  };
};
